<template>
  <div>
    <DataTable
      :value="jobFunctions"
      :paginator="true"
      dataKey="id"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedJobFunctions"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Job Functions"
    >
      <template #empty> No Job Functions found. </template>
      <template #loading> Loading Job Function data. Please wait. </template>
      <Column selectionMode="multiple" headerStyle="width: 3em;"></Column>
      <Column
        field="id"
        header="id"
        headerStyle="width: 3em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.id }}
          </div>
        </template>
      </Column>
      <Column
        field="jobFuncCode"
        header="Job Function Code"
        headerStyle="width: 10em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.jobFuncCode }}
          </div>
        </template>
      </Column>
      <Column
        field="jobFuncName"
        header="Job Function Name"
        headerStyle="width: 10em"
        :sortable="true"
      >
        <template #body="slotProps">
          <div>
              {{ slotProps.data.jobFuncName }}
          </div>
        </template>
      </Column>
      <Column
        field="active"
        header="Is Active"
        headerStyle="width: 9em"
        :sortable="true"
      >
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 7em;">
        <template #body="slotProps">
          <div
            :style="{position: 'relative'}"
          >
            <SplitButton 
              label="Edit" 
              icon="pi pi-info" 
              class="p-button-success p-mb-2"
              @click="editJobFunction(slotProps.data)" 
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script>
import PermissionMixin from '../../PermissionMixin.vue'
export default {
  mixins: [PermissionMixin],
  props: [
    'jobFunctions',
    'loading'
  ],
  data: () => ({
    selectedJobFunctions: null,
    filters: {
      global: ''
    }
  }),
  created() {
    this.filters.global = this.$route.query.search
  },
  methods: {
    getButtons(data) { 
      this.checkPermissions()
      let buttons = []
      if (this.deleteSettings) {
        buttons.push(
          {
            label: 'Delete',
            icon: 'pi pi-trash',
            command: () => {
              this.deleteJobFunction(data)
            }
          }
        )
      }
      return buttons
    },
    deleteJobFunction(jobFunction) {
      this.$emit('delete-jobFunction', jobFunction)
    },
    editJobFunction(jobFunction) {
      this.$emit('edit-jobFunction', jobFunction)
    }
  }
}
</script>

<style>

</style>